// Test sites for the open-vs-targeted-site search comparison
// (apps/api/src/search-compare/, apps/admin's /search-compare screen). One
// list, imported by both the admin form's default checkboxes and the CLI
// entrypoint kept for a developer without a browser — a curated list
// maintained in two places drifts the moment one of them is edited.

/** Google's `site:` operator accepts a bare registrable domain or a URL
 * prefix (`site:example.com/leaks/`) identically — no query-building branch
 * needed between the two, `value` goes straight after `site:` either way.
 * `type` exists so the UI can label what a manager pasted honestly. */
export interface TargetSearchScope {
  type: 'domain' | 'prefix';
  value: string;
}

export const DEFAULT_TEST_SITES: TargetSearchScope[] = [
  'nudogram.com',
  'picazor.com',
  'thefappening.plus',
  'fapeza.com',
  'hotzxgirl.com',
  'leakedmodels.com',
  'wildskirts.com',
  'leakgallery.com',
  'masterfap.net',
  'fapello.com',
  'fapelo.net',
  'babepedia.com',
  'pornpics.com',
  'xfrenchies.com',
].map((value) => ({ type: 'domain' as const, value }));
